module.exports = __webpack_public_path__ + "01_cheeks.050aa156.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/nakagawa/male/layer3/01_cheeks.png
// module id = cuP2
// module chunks = 0